import {WebsiteModel} from '../widgets/form-section/website-user-input/website.model';

export class Repository {
  public static Github = <WebsiteModel> {
    id: 0,
    displayName: 'Github',
    profileUrlPrefix: 'github.com/'
  };
  public static Bitbucket = <WebsiteModel> {
    id: 1,
    displayName: 'Bitbucket',
    profileUrlPrefix: 'bitbucket.org/'
  };
  public static GitLab = <WebsiteModel> {
    id: 2,
    displayName: 'Gitlab',
    profileUrlPrefix: 'gitlab.com/'
  };
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/network/repository.enum.ts